import {
  TARIFICATION_SESSION_APP_SUCCESS,
  TarificationAction,
} from "store/types/tarification.types";
import { GlobalState } from "store/configure-store";
import { TarificationApplicationSession } from "model/tarification.model";

export interface TarificationState {
  tarificationApplicationSession: TarificationApplicationSession;
}
export const initialTarificationState = {
  tarificationApplicationSession: new TarificationApplicationSession(),
};

/** ---- SELECTORS ---- */
export const selectTarificationApplicationSession = (
  state: GlobalState
): TarificationApplicationSession => {
  return state.tarification.tarificationApplicationSession;
};

/** ---- REDUCER ---- */
const tarificationSessionAppSuccess = (
  state: TarificationState,
  session: TarificationApplicationSession
) => {
  return { ...state, tarificationApplicationSession: session };
};

/** ---- REDUCER ---- */
export const tarificationReducer = (
  state: TarificationState = initialTarificationState,
  action: TarificationAction
): TarificationState => {
  switch (action.type) {
    case TARIFICATION_SESSION_APP_SUCCESS:
      return tarificationSessionAppSuccess(state, action.payload);
    default:
      return state;
  }
};
